export const townshipModelData = function () {
  return {
    success: null,
    townshipList: [],
    paginatedTownshipList: [],
    editDialog: false,
    FIPSList: [],
    queryParams: ''
  }
}
